import request from '../../../../../../logic/utils/request';

const URL = '/server/api/qcquestiontransition/';

// Сервер не отдаёт id перехода ни в additional_questions внутри qcsurvey,
// ни в дереве qcquestiontransition — его видно только в ответе на add.
// Поэтому отвязать можно лишь связь, созданную в текущей сессии.
// Когда бэкенд начнёт присылать transition_id в дереве, getTransitionId
// подхватит его без других правок.
export const getTransitionId = (additionalQuestion) => (
  additionalQuestion?.transition_id
  ?? additionalQuestion?.transitionId
  ?? additionalQuestion?.__transitionId
  ?? null
);

export const attachQuestion = async (answerId, questionId, position = 0) => {
  const res = await request(URL, 'add', { answerId, questionId, position });
  return res?.data?.data || null;
};

export const detachQuestion = async (transitionId) => {
  const res = await request(URL, 'delete', { id: transitionId });
  return res?.data?.data || null;
};

export const createQuestion = async (questiontext) => {
  const res = await request('/server/api/qcquestion/', 'add', {
    questiontext,
    operator_mark: false,
    correctAnswers: [],
  });
  return res?.data || null;
};

export const deleteQuestion = async (questionId) => {
  await request(`/server/api/qcquestion/${questionId}/`, 'delete');
};

export const fetchAllQuestions = async () => {
  const res = await request('/server/api/qcquestion/', 'get');
  return res?.data?.data || [];
};
